/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import useCustomNavigate from "../../components/customNavigationHook";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Dropdown, Menu, message, Input, Spin, Tooltip } from "antd";
import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import bell from "../../assests/images/bell.svg";
import mobileLogo from "../../assests/images/shree-maruti-logo.svg";
import hamIcon from "../../assests/images/maruti/hamburgerIcon.svg";
import hamburgerIcon from "../../assests/images/maruti/HamburgerIcon.png";
import hamburgerIconClosed from "../../assests/images/maruti/HamburgerCloseIcon.png";
import cart from "../../assests/images/cart.svg";
import balance from "../../assests/images/balance_white.svg";
import urls from "../../api/urls";
import API from "../../api";
import constants from "../../constants/constants";
import NetworkIndicator from "../NetworkIndicator";
const { ROLES } = constants;
const currentEnv = process.env.REACT_APP_ENV;

const { ADDRESS_PINCODE, DELCAPER_PINCODE_SERVICE, GET_WALLET_BALANCE } = urls;
import "./style.scss";

const AppHeader = ({
  showLogo,
  handleOpenDrawer = () => {},
  visibleDrawer,
  isMobile,
  showNotification,
  showNotificationBell,
  setShowNotification,
  setShowNotificationBell,
}) => {
  const navigate = useCustomNavigate();
  const [dateToFormat, setdateToFormat] = useState(new Date());
  const [userName, setUserName] = useState();
  const [cartDetails, setCartDetails] = useState(0);
  const [items, setItems] = useState([]);
  const [trackingNumber, setTrackingNumber] = useState("");

  const [lcrNumber, setLcrNumber] = useState("");
  const [walletBalance, setWalletBalance] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);

  let userinfo = JSON.parse(localStorage.getItem("userinfo"));

  const getRole = userinfo?.roles[0]?.replace(/.*_/, "");
  const { ROLES } = constants;
  const { HUB_ADMIN, HO_ADMIN, CP_ADMIN } = ROLES;
  const role = userinfo?.roles[0];
  const branchDetail = JSON.parse(
    localStorage.getItem("userinfo")
  )?.roles?.includes(CP_ADMIN)
    ? `(${JSON.parse(localStorage.getItem("selectedCompany"))?.label || ""})`
    : "";

  const profileDetails = useSelector(
    (state) => state.masterReducer.getProfileDetailsReducer,
    shallowEqual
  );
  const { result: profileDetailsResult } = profileDetails;

  useEffect(() => {
    if (profileDetailsResult) {
      setUserName(profileDetailsResult?.data.firstName);
    }
  }, [profileDetailsResult]);

  useEffect(() => {
    let userName = JSON.parse(localStorage.getItem("userName"));
    setUserName(userName);
  }, [localStorage.getItem("userName")]);

  useEffect(() => {
    setInterval(() => {
      let cartDetails = JSON.parse(localStorage.getItem("cartDetails"));
      setCartDetails(cartDetails ? cartDetails : 0);
    }, 1000);
  }, [localStorage.getItem("cartDetails")]);

  useEffect(() => {
    setInterval(() => setdateToFormat(new Date()), 30000);
  }, []);

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("userinfo"))?.roles?.includes(CP_ADMIN))
      getWalletBalance();
  }, []);

  const getWalletBalance = async () => {
    setIsRefreshing(true);
    const prospayCustomerId =
      JSON.parse(localStorage.getItem("selectedCompany"))?.prospayCustomerId ||
      null;
    // const prospayCustomerId = "SMLNBA000000000603325";
    const response = await API.Api(
      GET_WALLET_BALANCE + prospayCustomerId
    ).getWithToken();
    if (response?.status) {
      setWalletBalance(response?.response?.data?.data?.points || 0);
      //setWalletBalance(0);
      setIsRefreshing(false);
    } else {
      message.error(response?.response?.data?.message || "Network Error");
      setIsRefreshing(false);
    }
  };

  const menuClicked = ({ key }) => {
    if (+key === 4) {
      //window.location.assign("/");
      window.location.replace("/");
      let showNotice = localStorage.getItem("showNotice");
      localStorage.clear();
      localStorage.clear();
      document.cookie = "userToken=";
      localStorage.setItem("showNotice", showNotice);
    }
    if (+key === 2) {
      navigate("/profile");
    }
  };

  const menu = (
    <Menu
      className="nav-dropdown-a"
      onClick={menuClicked}
      items={[
        {
          label: `${userName} ${branchDetail || ""}`,
          // (
          //   <span>
          //     {userName} {branchDetails || ""}
          //   </span>
          // ),
          //`${userName} (${branchDetails?.label})`,
          key: "1",
          style: { fontSize: "14px" },
        },
        {
          type: "divider",
        },
        {
          label: "Profile",
          key: "2",
          style: { fontSize: "14px" },
          icon: <UserOutlined />,
          disabled: false,
        },
        {
          label: "Settings",
          key: "3",
          style: { fontSize: "14px" },
          icon: <SettingOutlined />,
          disabled: true,
        },
        {
          label: "Logout",
          key: "4",
          style: { fontSize: "14px" },
          icon: <LogoutOutlined />,
        },
      ]}
    />
  );

  const showMessage = () => {
    const key = "customMessageKey";
    message.error({
      content: "Invalid tracking number",
      duration: 1,
      className: "track-err-msg",
      key,
    });
  };

  const routeToTrackingforAwb = (e) => {
    if (e == "awb") {
      let track = trackingNumber;
      // if (track?.length == 11 || track?.length == 14) {
        let a = track;
        setTrackingNumber("");
        navigate("/shipment-tracker", {
          state: { awb: a, num: Math.random() },
        });
      // } else {
      //   showMessage();
      //   // message.error("Invalid tracking number", 20);
      // }
    } else {
      let track = lcrNumber.replace(/\s+/g, "");
      if (track.length <= 15) {
        let a = track;
        setLcrNumber("");

        navigate("/lcr-report", {
          state: { vehicle_lcr_id: a, lcr_num: a },
        });
      } else {
        showMessage();
        // message.error("Invalid tracking number", 20);
      }
    }
  };

  const handleInputChangeforAwb = (value) => {
    // if (!isNaN(value)) {
      setTrackingNumber(value);
    // }
  };
  const handleInputChangeForLcr = (value) => {
    if (!isNaN(value)) {
      setLcrNumber(value);
    }
  };

  const showCart = false;
  // JSON.parse(localStorage.getItem("userinfo"))?.roles?.includes(CP_ADMIN) ||
  // JSON.parse(localStorage.getItem("userinfo"))?.roles?.includes(HUB_ADMIN);

  const showWallet = JSON.parse(
    localStorage.getItem("userinfo")
  )?.roles?.includes(CP_ADMIN);

  return (
    <div className="header">
      <div className="header-content">
        <div className="d-flex space-between">
          <div className="space-between">
            <img
              src={hamIcon}
              className="mr-1 ham-mobile"
              onClick={handleOpenDrawer}
            />
            {/* {showLogo && ( */}
            <div className="banner">
              {!isMobile ? (
                <button onClick={handleOpenDrawer}>
                  {!visibleDrawer ? (
                    <img src={hamburgerIcon} className="ham-icon-header" />
                  ) : (
                    <img
                      src={hamburgerIconClosed}
                      className="ham-icon-closed-header"
                    />
                  )}
                </button>
              ) : null}
              <img src={mobileLogo} className="mobile-logo" />
            </div>
            {/* )} */}
            
            {/* Network Status Indicator - beside hamburger menu */}
            <div className={`network-indicator-wrapper ${visibleDrawer ? "sidebar-open" : ""}`}>
              <NetworkIndicator 
                position="inline"
                showDetails={false}
                showRefreshButton={false}
                size="small"
              />
            </div>
          </div>

          <div className="align-center">
            {role == HUB_ADMIN ? (
              <TrackingComponent
                trackingNumber={lcrNumber}
                handleInputChange={(e) => handleInputChangeForLcr(e)}
                routeToTracking={() => routeToTrackingforAwb("lcr")}
                placeholder="Enter LCR ID"
                buttonText="LCR track"
              />
            ) : null}
            <TrackingComponent
              trackingNumber={trackingNumber}
              handleInputChange={(e) => handleInputChangeforAwb(e)}
              routeToTracking={() => routeToTrackingforAwb("awb")}
              placeholder="Enter Tracking ID"
              buttonText="Track"
            />
            {/* <div className="time pr-1 align-center mr-1">
              <img src={calender} />
              <span>{MyComponent()}</span>
              <img src={clock} />
              <span>{time}</span>
            </div> */}

            {showWallet && (
              // <Tooltip
              //   title={
              //     <div
              //       style={{
              //         display: "flex",
              //         alignItems: "center",
              //         gap: "8px",
              //         padding: "4px 0",
              //       }}
              //     >
              //       <span style={{ fontSize: "14px" }}>
              //         Balance: ₹ {walletBalance || 0}
              //       </span>
              //       <ReloadOutlined
              //         onClick={(e) => {
              //           e.stopPropagation();
              //           getWalletBalance();
              //         }}
              //         style={{
              //           cursor: "pointer",
              //           fontSize: "14px",
              //           color: "#1890ff",
              //           transition: "all 0.3s",
              //         }}
              //         spin={isRefreshing}
              //       />
              //     </div>
              //   }
              //   placement="top"
              //   overlayInnerStyle={{
              //     minWidth: "100px",
              //   }}
              // >
              //   <div className="profile1 d-flex center">
              //     {/* {walletBalance > 0 && <div className="wallet-count"></div>} */}
              //     <img
              //       src={balance}
              //       alt="wallet"
              //       onClick={() => navigate("/my-wallet")}
              //       className="pointer"
              //     />
              //   </div>
              // </Tooltip>
              <div
                className="center"
                onClick={() => navigate("/my-wallet")}
                style={{
                  borderRadius: "20px",
                  borderWidth: "1px",
                  padding: "5px 10px",
                  backgroundColor: "white",
                  height: "30px",
                  cursor: "pointer",
                }}
              >
                <span style={{ fontSize: "15px" }}>
                  <span className="profile1" style={{ padding: "5.5px" }}>
                    <img
                      src={balance}
                      alt="wallet"
                      className="pointer"
                      width={"16px"}
                      style={{ marginTop: "-3px" }}
                    />
                  </span>{" "}
                  ₹ {walletBalance || 0}
                </span>{" "}
                &nbsp;
                <ReloadOutlined
                  onClick={(e) => {
                    e.stopPropagation();
                    getWalletBalance();
                  }}
                  style={{
                    cursor: "pointer",
                    fontSize: "16px",
                    color: "#1890ff",
                    transition: "all 0.3s",
                  }}
                  spin={isRefreshing}
                />
              </div>
            )}

            {showCart && (
              <div className="profile1 d-flex center ml-1">
                <img
                  src={cart}
                  alt="cart"
                  onClick={() => navigate("/cart-details")}
                  className="pointer"
                  disabled={true}
                />
                {cartDetails === 0 ? (
                  ""
                ) : (
                  <div className="cart-count">
                    <span>{cartDetails}</span>
                  </div>
                )}
              </div>
            )}

            <div
              className="profile1 d-flex center ml-1"
              style={{
                position: "relative",
                cursor: "pointer",
              }}
            >
              <div
                onClick={() => {
                  setShowNotificationBell(false);
                  setShowNotification(!showNotification);
                }}
              >
                <img src={bell} />
                {showNotificationBell ? (
                  <div
                    style={{
                      backgroundColor: "red",
                      width: 8,
                      height: 8,
                      position: "absolute",
                      top: 5,
                      right: 8,
                      borderRadius: 50,
                    }}
                  ></div>
                ) : null}
              </div>
            </div>
            
            <Dropdown overlay={menu} overlayClassName="nav-dropdown-overlay">
              <div className="d-flex center avatar">
                <span style={{ padding: "0 0 0 4px" }}>
                  {userName?.toUpperCase() + " "}({getRole})
                </span>
                <div className="profile1 d-flex center ml-1">
                  <a>{userName?.substring(1, 0).toUpperCase() || "?"}</a>
                </div>
              </div>
            </Dropdown>
          </div>
        </div>
        {/* {JSON.parse(localStorage.getItem("userinfo"))?.roles?.includes(
          CP_ADMIN
        ) && (
          <KycAlert isKyc={JSON.parse(localStorage.getItem("kycCompleted"))} />
        )} */}
      </div>
    </div>
  );
};
export default AppHeader;

function TrackingComponent({
  trackingNumber,
  handleInputChange,
  routeToTracking,
  placeholder,
  buttonText,
}) {
  const [pinCodeServiceableStatus, setPinCodeServiceableStatus] = useState();
  const [pincodeLoader, setPincodeLoader] = useState(false);
  const [pincode, setPincode] = useState("");

  const getDeliveryPincode = async (value) => {
    if (!isNaN(value)) {
      setPincode(value);
    }

    if (value?.length > 5) {
      setPincodeLoader(true);
      let getFromPincode = JSON.parse(localStorage.getItem("userId"));
      let response2 = await API.Api(DELCAPER_PINCODE_SERVICE).post({
        fromPincode: getFromPincode?.premises?.pincode || null,
        toPincode: +value,
      });
      if (response2?.status) {
        setPincodeLoader(false);
        const res = response2?.response?.data?.data?.pincodeData;
        const serviceability = res?.serviceability.serviceability;
        const city = res?.city;
        const state = res?.stateName;
        const pincode = res?.pincode || value;
        const zone = res?.zone;
        const status =
          serviceability === "Non-Serviceable" ? "error" : "success";
        const msg =
          serviceability === "Non-Serviceable" ? "Non-Serviceable-" : null;

        setPinCodeServiceableStatus({
          serviceability,
          status,
          msg,
          stateCode: res?.stateCode,
          city,
          state,
          pincode,
          zone,
        });
      } else {
        setPincodeLoader(false);
        setPinCodeServiceableStatus({
          serviceability: "",
          status: "error",
          msg: response2?.response?.data?.message,
          stateCode: "",
          city: "",
        });
      }
    }
  };

  return (
    <div className="align-center mr-1">
      <div>
        {/* Input Field */}
        <Input
          style={{
            borderRadius: "20px",
            width: "100%",
          }}
          showSearch
          value={pincode}
          onBlur={() => {
            setPinCodeServiceableStatus({});
            setPincode(null);
          }}
          maxLength={6}
          placeholder={"Pincode"}
          onChange={(e) => getDeliveryPincode(e.target.value)}
        />

        {pincode?.length > 5 && (
          <div
            style={{
              marginTop: "-12px", // space below the input
              // color: "green",
              fontSize: "14px",
              minWidth: "27%",
              position: "absolute",
              marginLeft: "2px",
              // height: "40px",
              padding: "10px",

              background: "white",
              // display: "flex",
              // alignItems: "center",
              borderRadius: "10px",
            }}
          >
            <Spin spinning={pincodeLoader}>
              <div
                // className={
                //   pinCodeServiceableStatus?.serviceability === "Regular"
                //     ? "green"
                //     : pinCodeServiceableStatus?.serviceability === "Premium"
                //     ? "orange"
                //     : "red"
                // }
                style={{
                  lineHeight: "12px",
                  fontSize: "12px",
                  fontWeight: "600",
                }}
              >
                {/* <p>{pinCodeServiceableStatus?.msg}</p> */}

                {pinCodeServiceableStatus?.msg == "Invalid pincode" ? (
                  <p
                    className={
                      pinCodeServiceableStatus?.serviceability === "Regular"
                        ? "green"
                        : pinCodeServiceableStatus?.serviceability === "Premium"
                        ? "orange"
                        : "red"
                    }
                  >
                    {pinCodeServiceableStatus?.msg}{" "}
                  </p>
                ) : (
                  <>
                    <div className="d-flex">
                      <p style={{ fontWeight: "400", width: "40%" }}>ZONE - </p>
                      <p>{pinCodeServiceableStatus?.zone || "NA"}</p>
                    </div>
                    <div className="d-flex">
                      <p style={{ fontWeight: "400", width: "40%" }}>CITY - </p>
                      <p> {pinCodeServiceableStatus?.city || "NA"}</p>
                    </div>
                    <div className="d-flex">
                      <p style={{ fontWeight: "400", width: "40%" }}>
                        STATE -{" "}
                      </p>
                      <p> {pinCodeServiceableStatus?.state || "NA"}</p>
                    </div>
                    <div className="d-flex">
                      <span style={{ fontWeight: "400", width: "40%" }}>
                        PINCODE -{" "}
                      </span>
                      <p> {pinCodeServiceableStatus?.pincode || "NA"}</p>
                    </div>
                    <div className="d-flex">
                      <span style={{ fontWeight: "400", width: "40%" }}>
                        SERVICEABILITY -{" "}
                      </span>
                      <p
                        className={
                          pinCodeServiceableStatus?.serviceability === "Regular"
                            ? "green"
                            : pinCodeServiceableStatus?.serviceability ===
                              "Premium"
                            ? "orange"
                            : "red"
                        }
                        style={{ fontSize: "16px" }}
                      >
                        {pinCodeServiceableStatus?.serviceability?.toUpperCase()}
                      </p>
                    </div>
                  </>
                )}
              </div>
            </Spin>
          </div>
        )}
      </div>

      <Input
        className="ml-1"
        style={{
          borderRadius: "20px",
          // borderTopLeftRadius: "20px",
          // borderBottomLeftRadius: "20px",
        }}
        value={trackingNumber}
        placeholder={placeholder}
        onChange={(e) => handleInputChange(e.target.value)}
        onPressEnter={routeToTracking}
      />
      {/* <Button
        style={{
          backgroundColor: "#2e77d0",
          borderTopRightRadius: "20px",
          borderBottomRightRadius: "20px",
          height: "30px",
          width: "30%",
        }}
        onClick={routeToTracking}
        className="save-btn"
      >
        {buttonText}
      </Button> */}
    </div>
  );
}
